import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * useHashHighlight · scrolls to and pulses an on-page element whose
 * data-record-id matches the URL hash. Enables cross-module deep links
 * like /suppliers#s1 landing on and momentarily highlighting a specific
 * watchlist row.
 */
export default function useHashHighlight() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const el = document.querySelector(`[data-record-id="${id}"]`);
    if (!el) return;
    const t = setTimeout(() => {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.add("mos-pulse");
      const clear = setTimeout(() => el.classList.remove("mos-pulse"), 2600);
      el.__mosPulseClearTimer = clear;
    }, 120);
    return () => clearTimeout(t);
  }, [hash]);
}
